(ns frontend.view.components.timeline.entry.company-update
  (:require
   [frontend.view.components.timeline.entry.declaration :as te]
   [frontend.view.components.timeline.entry.default-item :as default]
   [frontend.view.components.timeline.db :as db]
   [frontend.view.components.timeline.entry.utils :as utils]
   [clojure.string :as string]
   [potpuri.core :as p :refer [fn->>]]
   [cljs.reader :as edn]
   [common.localization :as loc]
   [common.entity :as zap-entity]
   [frontend.utils :as main-utils]
   [frontend.state.current-session :as session]
   [common.schema.registry :as registry]))

(defonce roles
         {:vp-marketing    "VP Marketing"
          :cipo            "CIPO"
          :cmo             "CMO"
          :advisor         "Advisor"
          :chief-engineer  "Chief engineer"
          :board-member    "Board Member"
          :founder-and-ceo "Founder & CEO"
          :ceo             "CEO"
          :cxo             "CXO"
          :cfo             "CFO"
          :co-founder      "Co-founder"
          :cio             "CIO"
          :cto             "CTO"
          :auditor         "Auditor"
          :founder         "Founder"
          :chairman        "Chairman"
          :coo             "COO"
          :chief-architect "Chief architect"
          :vp-sales        "VP Sales"
          :cso             "CSO"})

(defn title-generator
  [entry]
  (let [op (-> entry
               :audit/op)
        name (->> entry
                  :audit/target
                  (get @session/entities)
                  :asset/name)]
    (loc/tr op [name])))

(defmethod te/timeline-entry-view :op.company/update
  [{entry :entry target-person :target-person :as arg}]
  (let [tenant-schema @session/tenant-schema
        body-generator
        (fn [entry]
          (let [changes (:audit/target-changes entry)
                op-args (:audit/op-args entry)]
            [:div
             (when-not (and op-args (empty? changes))
               (doall (for [[f-key f-val] changes]
                        (when-not (some #{f-key}
                                        [:common/updated-by :common/updated-on
                                         :person/fullcontact-person])
                          (let [f-set (main-utils/if-bigdec-or-bigint-then-string (:set f-val))
                                f-unset (:unset f-val)
                                f-add (:add f-val)
                                f-remove (:remove f-val)
                                f-info (:timeline-info f-val)]
                            ^{:key (str "timeline-op-company-update" f-key)}
                            [:div
                             (case f-key
                               :db/id nil
                               (utils/arrow-message
                                (let [fs (registry/get-field-schema tenant-schema f-key)]
                                  (loc/field-name f-key fs))
                                (zap-entity/display-string f-set)))])))))]))]
    [default/timeline-item-view entry title-generator body-generator default/timestamp-generator]))
